import gql from 'graphql-tag';

const MUTATION_CREATE_PLAN_LEAD_REQUEST = gql`
  mutation createPlanLeadRequest($input: LandlordCreatePlanLeadRequestInput!) {
    landlordCreatePlanLeadRequest(input: $input)
  }
`;

const createPlanLeadRequest = client => ({ input }) =>
  client.mutate({
    mutation: MUTATION_CREATE_PLAN_LEAD_REQUEST,
    variables: {
      input
    }
  });

export default createPlanLeadRequest;
